import { StatusConfigService } from "src/app/pages/call-center/pages/status-config/services/status-config.service";
import { Client } from "./../../../../../clients/models/client.model";
import { Component, DestroyRef, inject, Input, OnInit } from "@angular/core";
import { DetailedListContact } from "../../../../models/detailed-list.model";
import { ContactService } from "../../../../contact.service";
import { DetailedListClient } from "../../../../models/detailed-list-client.model";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { StatusCliente } from "src/app/pages/call-center/pages/status-config/model/status.model";
import { CustomMessage } from "src/app/pages/call-center/pages/status-config/model/custom-message.model";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbActiveOffcanvas, NgbOffcanvas } from "@ng-bootstrap/ng-bootstrap";
import { ToastService } from "src/app/shared/toasts/toast-service";

@Component({
  selector: "app-detailed-list-client",
  templateUrl: "./detailed-list-client.component.html",
  styleUrl: "./detailed-list-client.component.scss",
})
export class DetailedListClientComponent implements OnInit {
  @Input() client!: DetailedListContact;

  removerContato = false;

  destroyedRef = inject(DestroyRef);
  clientRequest: DetailedListClient | null = null;
  statusMessages: StatusCliente[] = [];
  customMessages: CustomMessage[] | null = null;
  selectedCustomMessage: CustomMessage | null = null;
  statusId = "";
  message = "";
  scheduledDate = "";
  qualify = false;
  isLoading = false;
  novaMensagemForm!: FormGroup

  constructor(
    private contactService: ContactService,
    private statusConfigService: StatusConfigService,
    private offcanvasService: NgbActiveOffcanvas,
    private toastService: ToastService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.novaMensagemForm = this.fb.group({
      statusId: [],
      mensagemPersonalizada: [],
      mensagem: ['', Validators.required],
      dataAgendamento: [null],
      qualificarContato: new FormControl(false, { nonNullable: true }),
      mensagemRelevante: new FormControl(false, { nonNullable: true })
    })

    // Consulta followUp Atual
    this.contactService
      .getDetailedListClient(this.client.contatoGeradoId)
      .pipe(takeUntilDestroyed(this.destroyedRef))
      .subscribe({
        next: (client) => {
          this.clientRequest = client;
          this.scheduledDate =
            client.dataAgendamento &&
            new Date(client.dataAgendamento).toISOString().split("T")[0];
          this.statusId = client.statusClienteId;

          // Atualizando os valores no formulário
          this.novaMensagemForm.patchValue({
            statusId: client.statusClienteId,
            mensagem: '', // Se necessário, insira algum valor inicial
            dataAgendamento: client.dataAgendamento
              ? new Date(client.dataAgendamento).toISOString().split("T")[0]
              : null,
            qualificarContato: false, // Ajuste de acordo com os dados que deseja preencher
            removerContato: false,   // Ajuste de acordo com os dados que deseja preencher
            mensagemRelevante: false
          });
        },
        error: (error) => {
          console.error(error);
        },
      });

    // Consulta lista de status para selectListitem
    this.statusConfigService
      .getStatusMessages()
      .pipe(takeUntilDestroyed(this.destroyedRef))
      .subscribe({
        next: (status) => {
          this.statusMessages = status;
        },
        error: (error) => {
          console.error(error);
        },
      });

    this.statusConfigService
      .getCustomMessages()
      .pipe(takeUntilDestroyed(this.destroyedRef))
      .subscribe({
        next: (customMessages) => {
          this.customMessages = customMessages;
        },
        error: (error) => {
          console.error(error);
        },
      });
  }
  onSubmit(event: Event) {
    event.preventDefault();

    if (this.novaMensagemForm.invalid) {
      this.novaMensagemForm.markAllAsTouched();
      return;
    }

    if (this.removerContato) {
      const confirmacao = window.confirm("Tem certeza que deseja remover este contato? O contato não pode ser qualificado ao excluir.");
      if (!confirmacao) {
        return; // Sai do método sem excluir
      }
    }

    if (this.novaMensagemForm.valid) {

      this.isLoading = true;
      const formValues = this.novaMensagemForm.value;

      const data = {
        id: this.client.contatoGeradoId,
        statusClienteId: formValues.statusId,
        mensagem: formValues.mensagem,
        dataAgendamento: formValues.dataAgendamento,
        qualificarContato: formValues.qualificarContato,
        removerDaLista: this.removerContato,
        mensagemRelevante: formValues.mensagemRelevante || false
      };

      this.contactService
        .saveDetailedListClientData(data)
        .pipe(takeUntilDestroyed(this.destroyedRef))
        .subscribe({
          next: (result) => {
            this.offcanvasService.close();
            this.isLoading = false;
            this.toastService.show("Cliente atualizado com sucesso", {
              classname: "bg-success text-light",
            });
          },
          error: (error) => {
            this.toastService.show("Erro ao atualizar cliente", {
              classname: "bg-danger text-light",
            });
          },
        });
    }

  }

  onMensagemSelecionada(event: Event): void {
    const selectedMessageId = (event.target as HTMLSelectElement).value;

    if (selectedMessageId) {
      this.selectedCustomMessage = this.customMessages?.find(
        (msg) => msg.id === selectedMessageId
      ) || null;

      // Atualizando o valor do campo 'mensagem' no formulário
      this.novaMensagemForm.patchValue({
        mensagem: this.selectedCustomMessage?.mensagem || ''
      });
    }
  }

  onClose() {
    this.offcanvasService.close();
  }

}
